import React, { useContext, useState } from "react";
import pClasses from "../../ListUsersAndAdmins.module.scss";
import FriendlyInfo from "../../../FriendlyInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsAlt, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Table } from "react-bootstrap";
import RoundButton from "../../../Buttons/RoundButton";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import AlertDialog from "../../../../components/AlertDialog";
import * as h from "../../../../helpers";
import SessionContext from "../../../../context/sessionContext";

interface Interface {
  users?: any;
  date?: any;
  fetchedJourney?: any;
  style?: any;
  className?: string;
  companyUid?: string | null;
  showUser?: boolean;
  hideFilter?: boolean;
  showActiveStatus?: boolean;
  showBirthdate?: boolean;
  showCompany_uid?: boolean;
  showAccess_code?: boolean;
  _selectedJourney?: number;
}
interface TextDialogSecondary {
  localizacaoSonoraText: JSX.Element;
  fechamentoText: JSX.Element;
  figuraFundoText: JSX.Element;
  resolucaoTemporalText: JSX.Element;
  ordenacaoTemporalText: JSX.Element;
  dicoticosText: JSX.Element;
  localizacao_sonora: JSX.Element;
  fechamento_od: JSX.Element;
  fechamento_oe: JSX.Element;
  figura_fundo_od: JSX.Element;
  figura_fundo_oe: JSX.Element;
  resolucao_temporal: JSX.Element;
  ordenacao_temporal: JSX.Element;
  [key: string]: JSX.Element;
}

export default function ListUsers({
  className = "",
  fetchedJourney,
  _selectedJourney,
}: Interface) {
  const { t } = useTranslation();
  const ref: any = React.createRef();
  const [toHide, setHiddenInfo] = useState(false);
  const ListUsers = [] as Array<any>;
  const cSession = useContext(SessionContext);
  const { user } = cSession ?? {};

  useEffect(() => {
    setTimeout(() => {
      const image: any = document.getElementById(ref);
      html2canvas(image, {}).then((canvas: any) => {
        const imgData = canvas.toDataURL("image/jpeg");
      });
    }, 2000);
  }, []);

  const relat = new URL(window.location.href);
  let caixa = [] as Array<any>;
  caixa = relat.pathname.split("/").reverse();

  let _content = null;

  const nameUser = decodeURIComponent(caixa[1]).replace(/\./g, "");

  fetchedJourney &&
    fetchedJourney.avaliation.forEach((item: any, index: any) => {
      const reavaliationItem = fetchedJourney.reavaliation[index];
      ListUsers.push({ avaliation: item, reavaliation: reavaliationItem });
    });

  const testNamesDescription = [
    { localizacao_sonora: "localizacao_sonora_descricao" },
    { dicotico_digitos_separacao: "dicotico_digitos_separacao_descricao" },
    { dicotico_sequencial_competitivo: "dicotico_sequencial_descricao" },
    { figura_fundo_auditiva: "figura_fundo_auditiva_descricao" },
    { fechamento_auditivo: "fechamento_auditivo_descricao" },
    { resolucao_temporal: "resolucao_temporal_descricao" },
    { ordenacao_temporal: "ordenacao_temporal_descricao" },
  ];

  const localizacaoSonoraText = (
    <>
      <div>{t("tests.localizacao_sonora_info_alert1_admin")}</div>
      <br />
      <div>{t("tests.what_for")}</div>
      <br />
      <div>{t("tests.localizacao_sonora_info_alert2_admin")}</div>
    </>
  );
  const fechamentoText = (
    <>
      <div>{t("tests.fechamento_info_alert1_admin")}</div>
      <br />
      <div>{t("tests.what_for")}</div>
      <br />
      <div>{t("tests.fechamento_info_alert2_admin")}</div>
    </>
  );
  const figuraFundoText = (
    <>
      <div>{t("tests.figura_fundo_info_alert1_admin")}</div>
      <br />
      <div>{t("tests.what_for")}</div>
      <br />
      <div>{t("tests.figura_fundo_info_alert2_admin")}</div>
    </>
  );
  const resolucaoTemporalText = (
    <>
      <div>{t("tests.resolucao_temporal_info_alert1_admin")}</div>
      <br />
      <div>{t("tests.what_for")}</div>
      <br />
      <div>{t("tests.resolucao_temporal_info_alert2_admin")}</div>
    </>
  );
  const ordenacaoTemporalText = (
    <>
      <div>{t("tests.ordenacao_temporal_info_alert1_admin")}</div>
      <br />
      <div>{t("tests.what_for")}</div>
      <br />
      <div>{t("tests.ordenacao_temporal_info_alert2_admin")}</div>
    </>
  );
  const dicoticosText = (
    <>
      <div>{t("tests.dicoticos_info_alert1_admin")}</div>
      <br />
      <div>{t("tests.what_for")}</div>
      <br />
      <div>{t("tests.dicoticos_info_alert2_admin")}</div>
    </>
  );
  const textDialogSecondary: TextDialogSecondary = {
    localizacaoSonoraText: localizacaoSonoraText,
    fechamentoText: fechamentoText,
    figuraFundoText: figuraFundoText,
    resolucaoTemporalText: resolucaoTemporalText,
    ordenacaoTemporalText: ordenacaoTemporalText,
    dicoticosText: dicoticosText,
    localizacao_sonora: localizacaoSonoraText,
    fechamento_od: fechamentoText,
    fechamento_oe: figuraFundoText,
    figura_fundo_od: resolucaoTemporalText,
    figura_fundo_oe: ordenacaoTemporalText,
    resolucao_temporal: dicoticosText,
    ordenacao_temporal: localizacaoSonoraText,
    dicoticos_oe: dicoticosText,
    dicoticos_od: dicoticosText,
    dicotico_sequencial: dicoticosText,
  };
  const getColorFunctions = (testName: string) => {
    return {
      getColorScore: h.getColoresScoreGeneral,
      getColorsTime: h.getColoresTimeGeneral,
    };
  };
  const getTableBody = (items: any[]) => {
    return items.map((fetchedJourney: any) => {
      const {
        avaliation: {
          date_created,
          test_name,
          test_score,
          test_time,
          test_time_in_seconds,
        },
        reavaliation,
      } = fetchedJourney;
      const { getColorScore, getColorsTime } = getColorFunctions(test_name);

      const { colorScoreAvaliation, colorBorderScoreAvaliation } =
        getColorScore(test_score >= 0 ? test_score * 10 : null);
      const { colorScoreReavaliation, colorBorderScoreReavaliation } =
        getColorScore(
          reavaliation?.test_score >= 0 ? reavaliation.test_score * 10 : null
        );
      const { colorTimeAvaliation, colorBorderTimeAvaliation } =
        getColorsTime(test_time_in_seconds);
      const { colorTimeReavaliation, colorBorderTimeReavaliation } =
        getColorsTime(reavaliation?.test_time_in_seconds);
      const { colorTimeEvolucao, colorBorderTimeEvolucao } =
        h.getColorsTimeEvolucao(
          +reavaliation?.test_time_in_seconds - test_time_in_seconds
        );
      const { colorScoreEvolucao, colorBorderScoreEvolucao } =
        h.getColorsScoreEvolucao(+reavaliation?.test_score - test_score);

      const isGame = test_time ? true : false;

      const bgAndBorderStyle = (color: string, borderColor: string) => ({
        backgroundColor: color,
        borderColor: borderColor,
      });

      const play_score_avaliation = isGame ? test_score : "-";
      const play_score_reavaliation = isGame ? reavaliation?.test_score : "-";
      const play_time_avaliation = isGame ? test_time : "-";
      const play_time_reavaliation = isGame ? reavaliation?.test_time : "-";
      const play_time_Evolucao = isGame
        ? +reavaliation?.test_time_in_seconds - test_time_in_seconds
        : "-";

      //Caso não houver evolução, mostrar 0 e não números negativos
      const scoreEvolution =
        reavaliation?.test_score !== undefined 
          ? Math.max(
            0, reavaliation.test_score * 10 - test_score * 10 )
          : null;

      const play_Score_Evolucao = `${scoreEvolution}%`;
       
      const randomNumber = Math.floor(Math.random() * 100);
      return (
        <tr key={String(_selectedJourney + test_name + randomNumber)}>
          {/* mobile */}
          {/* precisa refazer a versão mobile dessa tabela */}
          {/* desktop */}
          <td className={` ${pClasses.Uppercase} ${pClasses.TdReport}`}>
            <b>
              <>
                {t(`tests.${fetchedJourney.avaliation.test_name}` + `_resume`)}
                <AlertDialog
                  className={pClasses.Dialog}
                  isConfirm={false}
                  isInfo={true}
                  textDialogPrimary={t(
                    `tests.${fetchedJourney.avaliation.test_name}`
                  )}
                  textDialogSecondary={
                    fetchedJourney.avaliation.test_name in textDialogSecondary
                      ? textDialogSecondary[fetchedJourney.avaliation.test_name]
                      : "..."
                  }
                />
              </>
            </b>
          </td>
          <td className={pClasses.TdNum}>
            <span
              className={
                isGame && fetchedJourney.avaliation?.test_score >= 0
                  ? pClasses.TagScore
                  : ""
              }
              style={bgAndBorderStyle(
                colorScoreAvaliation,
                colorBorderScoreAvaliation
              )}
            >
              {play_score_avaliation >= 0
                ? play_score_avaliation * 10 + "%"
                : null}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              className={
                isGame && fetchedJourney.avaliation?.test_time
                  ? pClasses.TagScore
                  : ""
              }
              style={bgAndBorderStyle(
                colorScoreAvaliation,
                colorBorderScoreAvaliation
              )}
            >
              {play_time_avaliation}
            </span>
          </td>
          <td className={pClasses.TdNum}>
            <span
              className={
                isGame && fetchedJourney.reavaliation?.test_score >= 0
                  ? pClasses.TagScore
                  : ""
              }
              style={bgAndBorderStyle(
                colorScoreReavaliation,
                colorBorderScoreReavaliation
              )}
            >
              {play_score_reavaliation >= 0
                ? play_score_reavaliation * 10 + "%"
                : null}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              className={
                isGame && fetchedJourney.reavaliation?.test_time
                  ? pClasses.TagScore
                  : ""
              }
              style={bgAndBorderStyle(
                colorTimeReavaliation,
                colorBorderTimeReavaliation
              )}
            >
              {fetchedJourney.reavaliation?.test_time
                ? play_time_reavaliation
                : null}
            </span>
          </td>
          <td className={pClasses.TdNum}>
            <span
              className={
                isGame && fetchedJourney.reavaliation?.test_score >= 0
                  ? pClasses.TagScore
                  : ""
              }
              style={bgAndBorderStyle(
                colorScoreEvolucao,
                colorBorderScoreEvolucao
              )}
            >
              {fetchedJourney.reavaliation
                ? play_Score_Evolucao
                : null}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              className={
                isGame && fetchedJourney.reavaliation?.test_time
                  ? pClasses.TagScoreEvolucao
                  : ""
              }
              style={bgAndBorderStyle(
                colorTimeEvolucao,
                colorBorderTimeEvolucao
              )}
            >
              {fetchedJourney.reavaliation?.test_time
                ? fetchedJourney.reavaliation?.test_time
                : null}
            </span>
          </td>
        </tr>
      );
    });
  };

  if (fetchedJourney) {
    _content = (
      <>
        <RoundButton
          small
          className={pClasses.BtnPdfSecondary}
          text={t("global.print_partial_report")}
          faIcon={faFilePdf}
          title={t("global.download_pdf")}
          onClick={() => pdfDownload()}
        />
        <div id={ref} style={{ paddingBottom: 150, paddingTop: 0 }}>
          <div id="refName" className={pClasses.hiddenName}>
            {decodeURIComponent(caixa[1]) && (
              <h1>
                {t("global.single_user")}: {decodeURIComponent(caixa[1])}
              </h1>
            )}
          </div>
          <Table
            striped
            bordered
            hover
            className={pClasses.TableResponsiveCenter}
          >
            <thead className={pClasses.TableHeadCenter}>
              <tr className={pClasses.TdHeigth}>
                {/* <th className={pClasses.TdMobile}>{t("global.tests")}</th> */}
                <th className={pClasses.TdReport}>{t("global.test")}</th>
                {/* <th className={pClasses.TdReport}>parâmetro ideal</th> */}
                <th className={pClasses.TdReport}>
                  {t("global.stage_1_title")}
                  <div className={pClasses.ThAvalDate}>
                    {`${
                      ListUsers &&
                      ListUsers.length > 0 &&
                      ListUsers[0]?.avaliation
                        ? `(${ListUsers[0]?.avaliation?.date_created
                            ?.split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                            .replace(/,/g, "/")})`
                        : "-"
                    }`}
                  </div>
                </th>
                <th className={pClasses.TdReport}>
                  {t("global.stage_3_title")}
                  <div className={pClasses.ThAvalDate}>
                    {`${
                      ListUsers &&
                      ListUsers.length > 0 &&
                      ListUsers[0]?.reavaliation
                        ? `(${ListUsers[0]?.reavaliation?.date_created
                            ?.split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                            .replace(/,/g, "/")})`
                        : "-"
                    }`}
                  </div>
                </th>
                <th className={pClasses.TdReport}>{t("global.evolution")}</th>
              </tr>
            </thead>
            <thead className={pClasses.TableHeadCenter}>
              <tr>
                <th className={pClasses.TdSub}></th>
                <th className={pClasses.TdSub}>
                  {t("global.score")}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t("global.time")}
                </th>
                <th className={pClasses.TdSub}>
                  {t("global.score")}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t("global.time")}
                </th>
                <th className={pClasses.TdSub}>
                  {t("global.score")}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t("global.time")}
                </th>
              </tr>
            </thead>
            <tbody className={pClasses.TableBody}>
              {getTableBody(ListUsers)}
            </tbody>
          </Table>
          <table>
            <div className={pClasses.testsDescricaoTitle}>
              {t(
                "tests.check_out_the_main_functions_of_hearing_skills_in_daily_life"
              )}
            </div>
            {testNamesDescription.map((test, index) => (
              <>
                <div
                  key={Object.keys(test)[0]}
                  className={pClasses.testsDescricaoName}
                >
                  {`${t("tests." + Object.keys(test)[0])}`}
                </div>
                <div
                  key={Object.keys(test)[0] + String(index)}
                  className={pClasses.testsDescricao}
                >
                  {`${t("tests." + Object.values(test)[0])}`}
                </div>
              </>
            ))}
          </table>
        </div>

        <div
          className={
            pClasses.Accessibility + " " + (toHide ? pClasses.Hide : "")
          }
          onClick={() => setHiddenInfo(true)}
        >
          <FontAwesomeIcon icon={faArrowsAlt} />
        </div>
      </>
    );
  }
  if (fetchedJourney && fetchedJourney.journey_code === -2) {
    _content = <FriendlyInfo text={t("infos.user_without_birthdate")} />;
  } else if (fetchedJourney && fetchedJourney.journey_code === -1) {
    _content = <FriendlyInfo text={t("infos.user_without_tests")} />;
  }
  const pdfDownload = () => {
    const input: any = document.getElementById(ref);
    html2canvas(input, {
      // scrollX: -window.scrollX,
      // scrollY: -window.scrollY,
      // windowWidth: document.documentElement.offsetWidth,
      // windowHeight: document.documentElement.offsetHeight,
    }).then((canvas: any) => {
      const pdf = new jsPDF("p");
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "png", 0, 0, 210, 320);
      pdf.save(
        `${
          user
            ? String(user?.registry).replace(".", "_")
            : nameUser?.replace(".", "_")
        }_Testes_Audiofoco.pdf`
      );
    });
  };

  return (
    <>
      {fetchedJourney ? (
        <div className={className + " " + pClasses.TableArea}>{_content}</div>
      ) : (
        <div className={pClasses.SpinerEndJouney}></div>
      )}
    </>
  );
}
